var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        closeColor: "#8e8e8e",
        backgroundColor: "white"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: {
                    primary: "",
                    loading: _vm.loading,
                    disabled: _vm.loading || !_vm.canConfirm,
                    "data-test": "confirm-btn"
                  },
                  on: { click: _vm.confirm }
                },
                [_vm._v(" " + _vm._s(_vm.confirmLabel) + " ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c(
            "span",
            {
              staticClass: "modal-title",
              attrs: { "data-test": "modal-title" }
            },
            [_vm._v(_vm._s(_vm.modalTitle))]
          )
        ]),
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "pa-4" },
            [
              _c("SearchContactList", {
                attrs: {
                  items: _vm.searchResults,
                  selected: _vm.selectedCliente,
                  loading: _vm.searching,
                  "display-field": ["nome_cliente"],
                  label: "Buscar cliente",
                  placeholder: "Nome, CPF, e-mail ou telefone",
                  noResultsText: "Nenhum cliente encontrado",
                  "data-test": "search-cliente"
                },
                on: {
                  search: _vm.onSearchInput,
                  select: _vm.selectCliente,
                  clear: _vm.clearSelectedCliente
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-avatar",
                          {
                            staticClass: "mr-2 flex-shrink-0",
                            attrs: { size: "28", color: "grey lighten-2" }
                          },
                          [
                            _c("span", { staticClass: "az-text-small" }, [
                              _vm._v(
                                _vm._s((item.nome_cliente || "?").charAt(0)) +
                                  " "
                              )
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "flex-grow-1 overflow-hidden" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "az-text-primary az-size-14 font-medium text-truncate"
                              },
                              [_vm._v(" " + _vm._s(item.nome_cliente) + " ")]
                            ),
                            _vm.getClienteSubtitle(item)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "az-text-small az-muted text-truncate"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.getClienteSubtitle(item)) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "selected",
                    fn: function(ref) {
                      var item = ref.item
                      var onClear = ref.onClear
                      return [
                        _c(
                          "v-avatar",
                          {
                            staticClass: "mr-2 flex-shrink-0",
                            attrs: { size: "28", color: "primary" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "white--text az-size-12",
                                staticStyle: { "font-size": "12px" }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      (item.nome_cliente || "?").charAt(0)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "flex-grow-1 overflow-hidden" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "az-text-primary az-size-14 font-medium text-truncate"
                              },
                              [_vm._v(" " + _vm._s(item.nome_cliente) + " ")]
                            ),
                            item.cpf
                              ? _c(
                                  "div",
                                  { staticClass: "az-text-small az-muted" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.formatCpf(item.cpf)) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-1",
                            attrs: { icon: "", "x-small": "" },
                            on: { click: onClear }
                          },
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: _vm.icons.close,
                                size: "14",
                                color: "#8E8E8E"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }